module.exports = __webpack_public_path__ + "img/change-product.5342c9b0.png";